import React, { memo } from "react";

import { LiveMissionsLoader } from "Pages/LiveMissionsPage/LiveMissionsPage.loader";
import { LiveMissionsController } from "Pages/LiveMissionsPage/LiveMissionsPage.controller";
import { MissionsPage } from "Components/MissionsPage/MissionsPage";

export const LiveMissionsPage = memo(() => {
  return (
    <LiveMissionsLoader>
      <LiveMissionsController />
      <MissionsPage />
    </LiveMissionsLoader>
  );
});
